module.exports = __webpack_public_path__ + "dental directions.png?bb316f9a55e5f28fa281559aae314d44";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customer_logos/dental/dental directions.png
// module id = 53
// module chunks = 0